import { css } from "@emotion/react";

export const regionStatHelpRoot = css({
    marginBottom: -70,
    marginLeft: -10,
    marginTop: 10,
});
